import {
    GET_WINE_AND_GRAPES_DATA_SUCCESS,
    GET_WINE_AND_GRAPES_DATA_FAIL,
    POST_WINE_AND_GRAPES_DATA_SUCCESS,
    POST_WINE_AND_GRAPES_DATA_FAIL,
    GET_WINE_AND_GRAPES_DATA_TOTALS_SUCCESS,
    GET_WINE_AND_GRAPES_DATA_TOTALS_FAIL
} from '../../../actions/carbonfootprint-rework/types/04-indirect-ghg-emissions-from-products-used-by-an-organisation';

const initialState = {
    loading: true,
    wineAndGrapesData: [],
    wineAndGrapesDataTotals: []
};

export default function indirectGhgEmissionsFromProductsForWineAndGrapesReducer(state = initialState, action) {
    const { type, payload } = action;

    switch (type) {
        case POST_WINE_AND_GRAPES_DATA_SUCCESS:
            return {
                ...state,
                loading: false,
            };
        case POST_WINE_AND_GRAPES_DATA_FAIL:
            return {
                ...state,
                loading: false
            }
        case GET_WINE_AND_GRAPES_DATA_SUCCESS:
            return {
                ...state,
                wineAndGrapesData: payload,
                loading: false,
            };
        case GET_WINE_AND_GRAPES_DATA_FAIL:
            return {
                ...state,
                wineAndGrapesData: payload,
                loading: false
            }
        case GET_WINE_AND_GRAPES_DATA_TOTALS_SUCCESS:
            return {
                ...state,
                wineAndGrapesDataTotals: payload,
                loading: false,
            };
        case GET_WINE_AND_GRAPES_DATA_TOTALS_FAIL:
            return {
                ...state,
                wineAndGrapesDataTotals: payload,
                loading: false
            }
        default:
            return state;
    }
}